import React, { useEffect, useState } from "react";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createWorkshop, deleteWorkshop, editWorkshop, getBrands, getCategories, getNetworks, getServices, getWorkshopAdmin } from "../../redux/workshopsAdmin/thunks";
import { selectWorkshopAdminBrands, selectWorkshopAdminBrandsLoading, selectWorkshopAdminCategories, selectWorkshopAdminList, selectWorkshopAdminListLoading, selectWorkshopAdminNetworks, selectWorkshopAdminNetworksLoading, selectWorkshopAdminServices, selectWorkshopAdminServicesLoading } from "../../redux/workshopsAdmin/selectors";
import { openModal } from "../../redux/modal/modalSlice";

const initialSortOptions = {
    columna: "id",
    sortOrderAsc: true

}

function WorkshopManagement() {
    const workshops = useSelector(selectWorkshopAdminList);
    const brands = useSelector(selectWorkshopAdminBrands);
    const networks = useSelector(selectWorkshopAdminNetworks);
    const categories = useSelector(selectWorkshopAdminCategories);
    const services = useSelector(selectWorkshopAdminServices);
    const dispatch = useDispatch();
    const loadingWorkhops = useSelector(selectWorkshopAdminListLoading);
    const loadingBrands = useSelector(selectWorkshopAdminBrandsLoading)
    const loadingNetworks = useSelector(selectWorkshopAdminNetworksLoading)
    const loadingServices = useSelector(selectWorkshopAdminServicesLoading) 
    const loading = (loadingWorkhops ==="loading" || loadingBrands === "loading" || loadingNetworks === "loading" || loadingServices === "loading" ? "loading" : loadingWorkhops)
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListWorkshops(mapPageInfo(workshops));
        dispatch(getBrands());
        dispatch(getNetworks());
        dispatch(getCategories());
        dispatch(getServices());

    }, [])
    
    function mapPageInfo(workshopsData){
        return {
            pageIndex: workshopsData.pageIndex ?? 0,
            pageSize: workshopsData.pageSize ?? 15,
            orderByField:  workshopsData.columna ?? "Id",
            orderByAscending: workshopsData.sortOrderAsc ?? true
        }
    }
      
    const getListWorkshops = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getWorkshopAdmin({query}));
    }

    function calculateBrandsValue(row){
        if(row.brands.length > 0)
          return  row.brands.map(rb=> brands.find(b=> b.brandId === rb).brandName).join(", ")
    }

    function calculateNetworksValue(row){
        if(row.networks.length > 0)
            return  row.networks.map(bs=> networks.find(n=> n.networkId === bs).networkName).join(", ")
    }

    function calculateServicesValue(row){
        if(row.services.length > 0)
            return  row.services.map(rs=> services.find(s=> s.serviceId === rs).serviceName).join(", ")
    }

    const columnsWorkshops = [
        <Column sortIndex={1} key={"workshops-1"} width="8%" dataField="externalId" caption="Id externo" />, 
        <Column key={"workshops-2"} width="8%" dataField="cif" caption="CIF" />,
        <Column key={"workshops-3"} width="8%" dataField="name" caption="Nombre" />,
        <Column key={"workshops-4"} width="8%" dataField="address" caption="Dirección" />,
        <Column key={"workshops-5"} width="8%" dataField="city" caption="Ciudad" />,
        <Column key={"workshops-6"} width="8%" dataField="province" caption="Provincia" />,
        <Column key={"workshops-7"} width="8%" dataField="postalCode" caption="Cod. Postal" />,
        <Column key={"workshops-8"} width="8%" dataField="phone" caption="Tlf." />,
        <Column key={"workshops-9"} lookup={{allowClearing: true, dataSource: categories, displayExpr:'description', valueExpr: 'categoryId'}} dataField="idBrandCategory" width="10%" caption="Categoría Marca"></Column>, 
        <Column key={"workshops-10"} lookup={{allowClearing: true, dataSource: categories, displayExpr: "description", valueExpr: "categoryId"}} dataField={"idNetworkCategory"}  width="8%" caption="Categoría Red"></Column>, 
        <Column key={"workshops-11"} width="8%" dataType={"number"} dataField="latitude" caption="Latitud" />,
        <Column key={"workshops-12"} width="8%" dataType={"number"} dataField="longitude" caption="Longitud" />,
        <Column key={"workshops-13"} width="8%" dataField="note" caption="Notas" />,
        <Column key={"workshops-14"} lookup={{multiple: true, allowClearing: true, dataSource: brands, displayExpr:'brandName', valueExpr: 'brandId'}} calculateDisplayValue={calculateBrandsValue}  width="10%" dataField="brands" caption="Marcas"></Column>,
        <Column key={"workshops-15"} lookup={{multiple: true, allowClearing: true, dataSource: networks, displayExpr:'networkName', valueExpr: 'networkId'}} calculateDisplayValue={calculateNetworksValue} width="10%" dataField="networks" caption="Redes"></Column>,
        <Column key={"workshops-16"} lookup={{multiple: true, allowClearing: true, dataSource: services, displayExpr:'serviceName', valueExpr: 'serviceId'}} calculateDisplayValue={calculateServicesValue} width="10%" dataField="services" caption="Servicios"></Column>,   
    ] 

    function handleSaveNewWorkshopClick(value, closeCreateModal) {   
            if(!validateWorkshopInfo(value))
                    return;

            const workshopParams ={
                body: {...value, latitude: value.latitude.toString(), longitude: value.longitude.toString()},
            }

            dispatch(createWorkshop(workshopParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListWorkshops(mapPageInfo({...workshops, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })
    }    

    function handleEditClick(value, closeEditModal) {
                if(!validateWorkshopInfo(value))
                        return;

                const body = {...value, latitude: value.latitude.toString(), longitude: value.longitude.toString()}

                dispatch(editWorkshop({body, param: value.id})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListWorkshops(mapPageInfo({...workshops, ...sortOptions}));
                        closeEditModal();
                    }    
                })
            }
                   
    const handleDeleteClick = (id, closeEditModal) => {
        dispatch(deleteWorkshop({param:id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = workshops.pageIndex;

                if (workshops.elements.length === 1) {
                    updatedPageIndex = Math.max(0, workshops.pageIndex - 1);
                }

                const updatedWorkshops = {
                    ...workshops,
                    pageIndex: updatedPageIndex,
                };

                getListWorkshops(mapPageInfo({...updatedWorkshops, ...sortOptions}));
                closeEditModal();               
            }
        })  
    }

    function validateWorkshopInfo(submitData){
        if(submitData.externalId.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Id Externo es obligatorio"}))
            return false;
        }
        if(submitData.name.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Nombre es obligatorio"}))
            return false;
        }
        if(submitData.city.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Ciudad es obligatorio"}))
            return false;
        }
        if(!submitData.latitude)
        {
            dispatch(openModal({type: "warning", message: "El campo Latitud es obligatorio"}))
            return false;
        }
        if(!submitData.longitude)
        {
            dispatch(openModal({type: "warning", message: "El campo Longitud es obligatorio"}))
            return false;
        }
        return true
    }


    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                defaultSortField={"Id"}
                sectionTitle={"Talleres"}
                masterTitle={"Taller"} 
                itemIdField={"id"} 
                itemDescriptionField={"name"} 
                loading={loading} 
                getData={getListWorkshops} 
                dataSource={workshops} 
                columnasTabla={columnsWorkshops} 
                numElements={[15, 30, 50]} 
                onCreate={handleSaveNewWorkshopClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                sortField={sortOptions}
                setsortField={setSortOptions}
            />               
        </div>
    )
}
export default WorkshopManagement;